<template lang="pug">
  b-container(style="margin-top:40px; padding-bottom: 20px;")
    store-detail(style="margin-bottom:20px")
    shipping-label-form
</template>

<script>
import StoreDetail from '../components/store/StoreDetail'
import ShippingLabelForm from '../components/delivery/ShippingLabelForm'

export default {
  components: {
    StoreDetail,
    ShippingLabelForm
  }
}
</script>
